import { oz } from '@weft/utils';
import { INTEGRATION_PROVIDERS } from '../integration-providers-schema';
import { OAuth2DataSchema } from '../oauth/oauth2-data-schema';

export const HubspotOAuthSchema = OAuth2DataSchema.extend({
  integrationProvider: oz.literal(INTEGRATION_PROVIDERS.hubspot),
});

export type HubspotOAuth = oz.infer<typeof HubspotOAuthSchema>;